import { useContext } from 'react'
import { InternalContext } from '../../contexts/InternalContext'
import { PartialRect } from '../../../interfaces/PartialRect'

const rect: PartialRect = { width: 984, left: 0 }

export function useChannelsElementRect(): PartialRect {
  return useContext(InternalContext).channelsElementRect || rect
}
